export default __webpack_public_path__ + "static/media/sunrise.8edf3053.jpg";